import { Button } from "@material-ui/core";
import { Language } from "@material-ui/icons";
import { useSettings } from "hooks";
import PropTypes from "prop-types";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

interface ButtonProps {
  label?: string | any;
  type?: "button" | "submit" | "reset";
  [key: string]: any;
}

const SubmitButton: FC<ButtonProps> = ({ label, type, ...other }) => {
  const {language} = useSettings()
  // console.log("other?.disabled ", other?.disabled);

  return (
    <Button
      sx={{ mt: 1, borderRadius: "40px" }}
      type={type}
      variant="contained"
      className={other?.disabled ? "" : "theme_btn"}
      {...other}
    >
      {label || language.webInfo_submit}
    </Button>
  );
};

SubmitButton.defaultProps = {
  label: "Submit",
  type: "submit",
};

SubmitButton.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
};

export default SubmitButton;
